export default {
  "realTimeRebateAdmin.thead.index": "#NO",
  "realTimeRebateAdmin.thead.gameType": "GameType",
  "realTimeRebateAdmin.thead.providerId": "ProviderId",
  "realTimeRebateAdmin.thead.userGroup": "UserGroup",
  "realTimeRebateAdmin.thead.vipGroup": "VipGroup",
  "realTimeRebateAdmin.thead.rollover": "Rollover",
  "realTimeRebateAdmin.thead.rebateConfig": "RebateConfig",
  "realTimeRebateAdmin.thead.createdAt": "CreatedAt",
  "realTimeRebateAdmin.thead.updatedAt": "UpdatedAt",
  "realTimeRebateAdmin.thead.status": "Status",
  "realTimeRebateAdmin.thead.active": "Active",
  "realTimeRebateAdmin.thead.mandatorySettlementCycle":
    "MandatorySettlementCycle",
  "realTimeRebateAdmin.thead.bonusPayoutStrategy": "BonusPayoutStrategy",
  "realTimeRebateAdmin.bonusPayoutStrategy.auto": "Auto",
  "realTimeRebateAdmin.bonusPayoutStrategy.manual": "Manual",
  "realTimeRebateAdmin.bonusPayoutStrategy.userCollection": "UserCollection",
  "realTimeRebateAdmin.thead.collectionTimeType": "CollectionTimeType",
  "realTimeRebateAdmin.thead.theNextDay": "TheNextDay",
  "realTimeRebateAdmin.thead.realTime": "RealTime",
  "realTimeRebateAdmin.thead.collectionTime": "CollectionTime",
  "realTimeRebateAdmin.thead.rewardExpirationDays": "RewardExpirationDays",
  "realTimeRebateAdmin.thead.bindSite": "BindSite",
  "realTimeRebateAdmin.thead.rebateSetting": "RebateSetting",

  "realTimeRebateAdmin.rebateSetting": "RebateSetting",
  "realTimeRebateAdmin.add": "Add",
  "realTimeRebateAdmin.edit": "Edit",
  "realTimeRebateAdmin.details": "Details",
  "realTimeRebateAdmin.delete": "Delete",
  "realTimeRebateAdmin.showConfig": "ShowConfig",

  "realTimeRebateAdmin.thead.action": "Action",
};
